import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Col, Label, Row, Textarea, Text,
} from 'idsk-react-components';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import ProcessTerminateButtons from './component/ProcessTerminateButtons';
import { terminateProcess } from '../../../client/pracovnyKrok/processTerminateClient';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import './processTerminate.scss';

const ProcessTerminate = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    wrapClient: terminateProcessClient,
    status: terminateProcessStatus,
  } = useClient(terminateProcess);
  const [dovodUkoncenia, setDovodUkoncenia] = useState<string>();
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const onTerminateProcess = async (): Promise<void> => {
    await terminateProcessClient(type, year, index, pracovnyKrokId, dovodUkoncenia);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="terminate-process">
      <Row>
        <Col>
          <Label htmlFor="dovodUkoncenia">Dôvod ukončenia procesu
            <Text type="span" className="terminate-process-not-required"> (nepovinný údaj)</Text>
          </Label>
        </Col>
        <Col widthDesktop="two-thirds">
          <Textarea
            name="dovodUkoncenia"
            rows={5}
            maxLength={2048}
            showRemaining
            expandHeight
            onChange={
              ({ target }) => {
                setDovodUkoncenia(target.value);
                clearFieldErrorMessage('dovodUkoncenia');
              }
            }
            error={getFieldErrorMessage('dovodUkoncenia')}
          />
        </Col>
        <Col>
          <ProcessTerminateButtons
            onClick={onTerminateProcess}
            loading={terminateProcessStatus.loading}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProcessTerminate;
